export const isPasswordStrong = (password: string): boolean => {
    // Check if the password is at least 8 characters long
    if (password.length < 8) {
        return false;
    }

    // Check if the password contains at least one capital letter
    if (!/[A-Z]/.test(password)) {
        return false;
    }

    // Check if the password contains at least one number
    if (!/\d/.test(password)) {
        return false;
    }

    // All conditions are met, the password is strong
    return true;
};
